var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        ref: "modal",
        staticClass: "modal fade",
        attrs: { tabindex: "-1", role: "dialog" }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h4",
                  { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
                  [_vm._v(_vm._s(_vm.$t("txtPrintQr")))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("txtPrintQr")) + "\n          "
                ),
                _vm.cells.length < 10
                  ? _c(
                      "ul",
                      _vm._l(_vm.cells, function(item) {
                        return _c("li", [_vm._v(_vm._s(item.name))])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("cellCount")) +
                      ": " +
                      _vm._s(_vm.cells.length)
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-2" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("cellPrintQrFormat")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-4" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.printQrFormat,
                            expression: "printQrFormat"
                          }
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.printQrFormat = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "1" } }, [
                          _vm._v("Z79x87")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "2" } }, [_vm._v("A4")]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "3" } }, [
                          _vm._v("Z90x55")
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-2" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("cell.print.qr.label")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-10 d-flex flex-row" },
                    [
                      _c("CellQrLabelOptionSelector", {
                        staticClass: "mr-2",
                        model: {
                          value: _vm.printLabel1,
                          callback: function($$v) {
                            _vm.printLabel1 = $$v
                          },
                          expression: "printLabel1"
                        }
                      }),
                      _vm._v(" "),
                      _c("CellQrLabelOptionSelector", {
                        model: {
                          value: _vm.printLabel2,
                          callback: function($$v) {
                            _vm.printLabel2 = $$v
                          },
                          expression: "printLabel2"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.dismiss }
                  },
                  [_vm._v(_vm._s(_vm.$t("btnClose")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.dismiss()
                        _vm.generateNfc()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("btnPrintNfc")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.dismiss()
                        _vm.generateQR()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("btnPrintQr")) +
                        "\n          "
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }